import React, { useState } from "react";
import cn from "classnames";
import OutsideClickHandler from "react-outside-click-handler";
import styles from "./Actions.module.sass";
import Icon from "../Icon";
import { Link } from "react-router-dom";

const Actions = ({
  className,
  classActionsHead,
  classActionsBody,
  classActionsOption,
  items,
  visible,
  setVisible,
  small,
  up,
  icon,
  extraSmall,
  BtnTitle
}) => {

  const [innerVisible, setInnerVisible] = useState(false);

  const toggle = () => {
    setVisible ? setVisible(!visible) : setInnerVisible(!innerVisible);
  };

  const action = (actionToPerform) => {
    actionToPerform()
  }
  return (
    <OutsideClickHandler
      onOutsideClick={() =>
        setVisible ? setVisible(false) : setInnerVisible(false)
      }
    >
      <div
        className={cn(
          styles.actions,
          className,
          {
            [styles.small]: small,
          },
          {
            [styles.up]: up,
          },
          {
            [styles.active]: visible ? visible : innerVisible,
          }
        )}
      >
        <button
          className={cn(styles.head, classActionsHead)}
          onClick={() => toggle()}
        >
          {icon ? <Icon name={icon} size="20" /> : <Icon name="more-horizontal" size="24" />}
          {BtnTitle && BtnTitle}
        </button>
        <div style={{
          width: extraSmall ? "160px" : "",
          height: extraSmall ? "80px" : ''
        }} className={cn(styles.body, classActionsBody)}>
          {items.map((x, index) => (
            <button
              style={{
                height: extraSmall ? '30px' : ''
              }}
              className={cn(styles.option, classActionsOption)}
              onClick={() => {
                action(x.action)
                setVisible(false)
              }
              }
              key={index}
            >
              {x.icon && <Icon name={x.icon} size="20" />}
              {x.title}
            </button>
          ))}
        </div>
      </div>
    </OutsideClickHandler>
  );
};

export default Actions;
